import AsyncStorage from '@react-native-async-storage/async-storage';
import { useIsFocused } from '@react-navigation/native';
import { LinearGradient } from 'expo-linear-gradient';
import React, { useRef, useState } from 'react';
import { Modal, Text, TextInput, TouchableOpacity, View } from 'react-native';
import Button from '../../components/Button';
import HeaderTabs from '../../components/HeaderTabs';
import ModalPaperWalletDeposit from '../../components/ModalPaperWalletDeposit';
import paperWalletService from '../../services/paperWalletService';
import toast from '../../utils/toast';
import styles from "./styles";



const PaperWalletDeposit = ({ navigation, route }) => {

    const ref = useRef(null);
    const isFocused = useIsFocused();

    const [modalVisible, setModalVisible] = useState(false);
    const [code, setCode] = useState('');
    const [validationCode, setValidationCode] = useState(0);
    
    const deposit = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        paperWalletService.deposit(token, code, {
            validation_code: validationCode
        }).then((response) => {
            if(response.status) {
                setModalVisible(true);
            }else{
                if(response?.data?.message) {
                    toast(response?.data?.message, "#DA1414");
                }else{
                    toast("Ocorreu um problema ao realizar o depósito! Verifique o código e a senha", "#DA1414");
                }
            }
        }).catch((error) => {
            if(error.response?.data?.message) {
                toast(error.response?.data?.message, "#DA1414");
            }else{
                toast("Ocorreu um problema ao realizar o depósito! Verifique o código e a senha", "#DA1414");
            }
        });
    }

    return (
        <>
            <HeaderTabs
                title={"Depositar Paper Wallet"}
                iconLeft={"settings"}
                routeLeft={"MyAccount"}
                subtitle={"Depósito de Paper Wallet"}
            />
            <View style={styles.container}>
                <View style={styles.view}>
                    <Text style={styles.label}>Digite o código da Paper Wallet</Text>
                    <TextInput
                        value={code}
                        placeholder="Código"
                        style={styles.input}
                        autoCapitalize="none"
                        keyboardType='numeric'
                        onChangeText={(val) => setCode( val.replace(/[^0-9]/g, '') )}
                    ></TextInput>

                    <Text style={styles.label}>Digite a senha</Text>
                    <TextInput
                        value={validationCode}
                        placeholder={"Digite a senha"}
                        style={styles.input}
                        autoCapitalize="none"
                        maxLength={10}
                        onChangeText={(val) => setValidationCode( val.toUpperCase() )}
                    ></TextInput>
                </View>
            </View>
            {
                (
                    code && validationCode ?
                        (
                            <TouchableOpacity
                            style={{ width: "90%", alignSelf: 'center', marginBottom: 20 }}
                            onPress={() => {deposit()}}
                              >
                                <LinearGradient
                                start={{ x: -1, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={["#16195B", "#1d8da5"]}
                                style={styles.action_button}
                                >
                                    <Text style={styles.action_button_text}>Depositar Paper Wallet</Text>
                                </LinearGradient>
                          </TouchableOpacity>
                        )
                        :
                        (
                            <Button text={"PREENCHA OS CAMPOS"} disabled={true} />
                        )
                )
            }

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                <ModalPaperWalletDeposit
                    handleCloseModal={() => {
                        setModalVisible(false);
                        navigation.navigate('Tabs');
                    }} 
                    handleCloseWithTransaction={() => {
                        setModalVisible(false);
                        navigation.navigate({ name: 'Tabs', params: { openTransaction: false } });
                    }}
                    />
            </Modal>
        </>
    );
}

export default PaperWalletDeposit;